import { StatusEnum } from "./types";

export const STATUS_TRANSITIONS_OPTIONS: Record<StatusEnum, StatusEnum[]> = {
  [StatusEnum.Unknown]: [],
  [StatusEnum.Draft]: [],
  [StatusEnum.Processing]: [],
  [StatusEnum.Completed]: [StatusEnum.Approved, StatusEnum.Archived, StatusEnum.Completed],
  [StatusEnum.Approved]: [StatusEnum.Approved, StatusEnum.Archived, StatusEnum.Completed],
  [StatusEnum.Archived]: [StatusEnum.Approved, StatusEnum.Archived, StatusEnum.Completed],
  [StatusEnum.Error]: [],
};

export const SHOW_ACTIVITY_LOG = [
  StatusEnum.Approved,
  StatusEnum.Completed,
  StatusEnum.Archived,
  StatusEnum.Processing,
];
export const SCENARIO_STATUS_TO_ARCHIVE = [StatusEnum.Approved, StatusEnum.Completed];
